import styled from 'styled-components';

export const RegistroComponent = styled.tr.attrs({
    className: ``
})`



`